// MUI components
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { Button } from '@mui/material';

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const BottomRowWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: 4,
}));
export const QuickFilterCnt = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: 4,
  maxHeight: 400,
  height: 400,
  '& .filterList': {
    width: '180px',
    maxWidth: '180px',
    flex: ' 1 0 180px',
    overflowY: 'auto',
  },
  '& .filterRow': {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 calc(100% - 180px)',
    maxWidth: 'calc(100% - 180px)',
    padding: '0 10px',
  },
  '& .ScrollableFilterRows': {
    height: '100%',
    overflowY: 'auto',
    marginBottom: 10,
  },
}));

export const AddFilterButton = styled(Button)(({ theme }) => ({
  fontSize: '13px',
  fontWeight: '500',
  lineHeight: '22px',
  width: 82,
  padding: '4px 0px',
  marginTop: 8,
  '& > span': {
    marginRight: 4,
  },
  '& > span > svg': {
    fontSize: '18px !important',
  },
}));
export const FilterTextRenderer = styled(Typography)(({ theme }) => ({
  fontSize: 'inherit',
  fontWeight: 600,
  lineHeight: 'inherit',
  marginTop: 0,
  color: 'inherit',
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textAlign: 'left',
  '& > span': {
    fontWeight: 400,
    color: '#000000',
  },
}));
